// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_refunds_cancel_body = /** @type {(inputs: {}) => string} */ () => {
	return `Changed your mind? You can cancel your order within 2 hours of placing it by contacting us directly. After that, you can still return the item once delivered.`
};

const el_refunds_cancel_body = /** @type {(inputs: {}) => string} */ () => {
	return `Αλλάξατε γνώμη; Μπορείτε να ακυρώσετε την παραγγελία σας εντός 2 ωρών από την υποβολή της επικοινωνώντας μαζί μας. Μετά, μπορείτε να επιστρέψετε το προϊόν μόλις το παραλάβετε.`
};

const ru_refunds_cancel_body = /** @type {(inputs: {}) => string} */ () => {
	return `Передумали? Вы можете отменить заказ в течение 2 часов после его оформления, связавшись с нами. После этого вы сможете вернуть товар после доставки.`
};

const he_refunds_cancel_body = /** @type {(inputs: {}) => string} */ () => {
	return `שיניתם את דעתכם? ניתן לבטל הזמנה תוך שעתיים מרגע ביצועה באמצעות פנייה ישירה אלינו. לאחר מכן, ניתן להחזיר את הפריט לאחר קבלתו.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const refunds_cancel_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.refunds_cancel_body(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("refunds_cancel_body", locale)
	if (locale === "en") return en_refunds_cancel_body(inputs)
	if (locale === "el") return el_refunds_cancel_body(inputs)
	if (locale === "ru") return ru_refunds_cancel_body(inputs)
	if (locale === "he") return he_refunds_cancel_body(inputs)
	return "refunds_cancel_body"
};